import _BaseBrick from "./_baseBrick";

export default class BrickDefault extends _BaseBrick {
  constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame: number, props?: any) {
    super(scene, x, y, texture, frame, props);


  }
}